<template>
	<div :style="{width: displayWidth}" class="pa-1">
		<v-card width="100%" class="mw-tile" tile :color="userColor" :dark="dark">
			<v-hover v-slot:default="{ hover }" open-delay="100">
				<v-card-title>
					<span>{{title}}</span>
					<v-spacer></v-spacer>
					<div v-if="editable && hover">
						<v-btn small :color="textColor" icon @click="demote"><v-icon small>mdi-arrow-up-bold</v-icon></v-btn>
						<v-btn small :color="textColor" icon @click="promote"><v-icon small>mdi-arrow-down-bold</v-icon></v-btn>
						<v-btn small :color="textColor" icon @click="toggle('userWidth', widths)"><v-icon small>mdi-arrow-top-right-bottom-left-bold</v-icon></v-btn>
						<v-btn small :color="textColor" icon @click="toggle('userColor', colors)"><v-icon small>mdi-format-color-fill</v-icon></v-btn>
					</div>
				</v-card-title>
			</v-hover>
			<v-card-text>
				<slot name="content"></slot>
			</v-card-text>
			<v-card-actions>

				<v-btn :color="textColor" x-small text v-if="unsaved" @click="saveTile" :disabled="saving">{{ saving ? 'Saving' : 'Save' }} Changes</v-btn>
				<v-spacer></v-spacer>
				<v-btn fab small
					v-for="(button, i) in buttons" 
					:key="i"  
					:color="button.color || 'accent'" 
					@click="click(button)"
					dark
				>
					<v-icon>{{ button.icon || 'mdi-arrow-right-bold'}}</v-icon>
				</v-btn>
			</v-card-actions>
		</v-card>
	</div>
</template>
<style>
	.mw-tile{
		float: left;
	}
</style>

<script type="text/javascript">
	import Vuex from "vuex";
	export default {
		name: "Tile", 
		props: {
			id: {type: String},
			buttons: {type: Array},
			editable: {type: Boolean, default: () => true }, 
			position: {type: Number, default: () => 0 }, 
			title: {type: String}, 
			width: {type: String, default: () => "33%" },
			color: {type: String, default: () => "white" }
		},
		data: () => {
			return {
				saving: false,
				unsaved: false,
				userPosition: 0,
				userWidth: "33%",
				userColor: "white", 
				widths: ["15%", "25%", "33%", "50%", "75%", "100%"], 
				colors: ["white", "primary", "accent", "grey", "lightGrey"],
			}
		},
		computed: {
			...Vuex.mapState({
				user: state => state.user,
				dashboardSettings: state => state.user.dashboard_settings
			}),
			dark(){
				if( this.userColor == "white"  || this.userColor == 'lightGrey'){
					return false;
				}
				return true;
			},
			textColor(){
				if( this.userColor == "white"  || this.userColor == 'lightGrey'){
					return "grey";
				}
				return "white"
			},
			isMobile(){
				return (this.$vuetify.breakpoint.sm || this.$vuetify.breakpoint.xs)
			},
			displayWidth(){
				return this.isMobile ? "100%" : this.userWidth;
			}
		},
		methods:{
			click(btn){
				// console.log( btn.emit );
				this.$emit(btn.emit)
			}, 
			toggle(property, array){
				var current = array.indexOf( this[property] );
				current++;
				if( current == array.length ){
					current = 0;
				}
				this[property] = array[current];
				this.unsaved = true;
			}, 
			demote(){
				this.userPosition++;
				this.saveTile();

			}, 
			promote(){
				this.userPosition--;
				this.saveTile();
			},
			saveTile(){
				var id = this.id || this.title.replace(/[^A-Z0-9]+/ig, "_");
				var dashboardSettings = this.dashboardSettings || {} 
				var currentSettings = dashboardSettings[id] || {};
				currentSettings.color = this.userColor;
				currentSettings.width = this.userWidth;
				currentSettings.position = this.userPosition;
				dashboardSettings[id] = currentSettings;
				var data = {dashboard_settings: dashboardSettings};
				var update = {
					data: data,
					doc: `users/${this.user.id}`,
					action: "update"
				}
				this.saving = true;
				this.$store.dispatch("updateDoc", update ).then(() => {
					this.unsaved = false;
					this.saving = false;
				})
			}
		}, 

		watch: {
			dashboardSettings: {		
				immediate: true,
				handler() {
					var id = this.id || this.title.replace(/[^A-Z0-9]+/ig, "_");
					var settings = this.dashboardSettings[id];
					if( settings ){
						this.userWidth = settings.width;
						this.userColor = settings.color;
						this.userPosition = settings.position;
					}
					else{
						this.userWidth = this.width;
						this.userColor = this.color;
						this.userPosition = this.position;

					}
				}
			}			

		}

	}
</script>
